"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkdownMessage = void 0;
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const MarkdownMessage = () => {
    return (react_1.default.createElement(polaris_1.Text, { as: 'span', variant: 'bodySm' },
        "Supports\u00A0",
        react_1.default.createElement(polaris_1.Link, { removeUnderline: true, target: '_blank', url: 'https://www.markdownguide.org/basic-syntax/' }, "Markdown syntax")));
};
exports.MarkdownMessage = MarkdownMessage;
